/**
 * Development-only logging utility
 * Works in both Node.js (backend) and browser (frontend) environments
 * Logs are only output in development mode, not in production builds
 * 
 * IMPORTANT: In production builds, this entire function call will be removed
 * by tree-shaking/dead code elimination, making it impossible to re-enable
 * logging by modifying the dist files.
 */

// This constant will be replaced at build time and enable tree-shaking
const __IS_DEV__ = (() => {
    try {
        // @ts-ignore
        if (typeof import.meta !== 'undefined' && import.meta.env) {
            return !!import.meta.env.DEV;
        }
        if (typeof process !== 'undefined' && process.env) {
            return process.env.NODE_ENV !== 'production';
        }
    } catch {
        return false;
    }
    return false;
})();

export const logDev = (msg: string, ...args: any[]): void => {
    if (__IS_DEV__) {
        console.log(`[DEV] ${msg}`, ...args);
    }
};


